import {
  faCheckCircle,
  faClock,
  faTimesCircle,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';
import classNames from 'classnames';

import { FindingValidations } from '@/@types/persistUserValidations';

interface Props {
  disabled?: boolean;
  isSelected?: boolean;
  onClick: () => void;
  value: FindingValidations | 'Delete';
}

export const ValidationButton = ({
  disabled,
  isSelected,
  onClick,
  value,
}: Props) => {
  const { t } = useLingui();

  const getIcon = () => {
    switch (value) {
      case FindingValidations.Agree:
        return faCheckCircle;
      case FindingValidations.Disagree:
        return faTimesCircle;
      case FindingValidations.Monitor:
        return faClock;
      case 'Delete':
        return faTrash;
    }
  };

  const getLabel = () => {
    switch (value) {
      case FindingValidations.Agree:
        return t`Confirm`;
      case FindingValidations.Disagree:
        return t`Reject`;
      case FindingValidations.Monitor:
        return t`Monitor`;
      case 'Delete':
        return t`Delete`;
    }
  };

  return (
    <button
      className={classNames(
        'vai-flex vai-flex-col vai-items-center disabled:vai-opacity-70 disabled:vai-cursor-not-allowed',
        {
          'hover:[&>svg]:vai-text-slate-300': !isSelected && !disabled,
        },
      )}
      disabled={disabled}
      onClick={onClick}
      data-testid={value === 'Delete' ? 'delete-annotation-button' : undefined}
    >
      <FontAwesomeIcon
        className={classNames({
          'vai-text-slate-400': value === 'Delete' || !isSelected,
          'vai-text-green-600':
            isSelected && value === FindingValidations.Agree,
          'vai-text-blaze-600':
            isSelected && value === FindingValidations.Disagree,
          'vai-text-orange-400':
            isSelected && value === FindingValidations.Monitor,
        })}
        icon={getIcon()}
        size="xl"
      />
      <p className="vai-font-inter vai-text-[12px] vai-font-semibold vai-text-foreground-dark">
        {getLabel()}
      </p>
    </button>
  );
};
